<div class="user-menu">

  <lib-dynamic-menu [menuItems]="userMenuItems" (onClickMenuEvent)="onClickMenuEvent($event)"></lib-dynamic-menu>
</div>
